<button type="button" class="workspace-card" (click)="onClick()">
  <div class="workspace-icon" *ngIf="safeIcon" [innerHTML]="safeIcon"></div>
  <div class="workspace-info">
    <span class="workspace-name">{{ workspace.name }}</span>
    <span class="info-icon" (click)="onInfoClick($event)">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z"
          stroke="#A1A1A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10 13.3333V10" stroke="#A1A1A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10 6.66667H10.0083" stroke="#A1A1A1" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </span>
  </div>
  <!--
  <div class="arrow-icon">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 15L12.5 10L7.5 5" stroke="#131313" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  </div>
  -->

  <div class="tooltip" *ngIf="workspace.tooltip">
    <p class="tooltip-text">{{ workspace.tooltip }}</p>
    <div class="tooltip-tail"></div>
  </div>
</button>